<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/home">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
          <a-card :loading="loading.page" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">{{ "expenditure Plan Manifest".toUpperCase() }}</h4>
              <small># {{ data.header.no_rencana_belanja }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button-group class="width-full">
                    <a-button
                      type="danger"
                      icon="edit"
                      class="width-full"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.header.tgl_buat).format(getDefaultDateFormat)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.header.pembuat
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Periode</span>
                  <span class="m-list-desc">{{ data.header.periode_bulan }} - {{ data.header.periode_tahun }}</span>
                </li>
                <li>
                  <a-table
                    :columns="columns"
                    :dataSource="data.detil"
                    id="table_dtl"
                    size="small" 
                    :pagination="false"
                    :loading="loading.page"
                    :scroll="{ x: 1000, y: '100vh' }"
                    bordered
                    class="margin-top"
                  >
                    <template slot="no" slot-scope="text,item,index">
                      {{ index+1 }}
                    </template>
                    <template slot="cost_center" slot-scope="item">
                      {{ item.cost_center_kode }}
                    </template>
                    <template slot="code_budget" slot-scope="item">
                      <div>{{ item.kode_anggaran }}</div>
                      <div>{{ item.item_anggaran }}</div>
                    </template>
                    <template slot="description" slot-scope="item">
                      {{ item.deskripsi }}
                    </template>
                    <template slot="nilai" slot-scope="item">
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="item.nilai_rencana"
                      />
                    </template>
                    <!-- <template slot="aksi" slot-scope="item">
                      <a-button size="small" icon="close" type="danger" 
                        :loading="loading.delete_key==item.rencana_belanja_dtl_id"
                        @click="handleDelete(item)">
                      </a-button>
                    </template> -->
                    <template slot="footer">
                      <b>Total Expenditure Plan : </b> {{ formatRupiah(totalValue).replace(",00", "") }}
                    </template>
                  </a-table>
                </li>
              </ul>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ManifestPlanExpenditure",
  props: ["id", "user_pembuat"],
  mixins: [GlobalMethod, CurrencyFormat, HandleRoute],
  data() {
    return {
      loading: {
        page: true,
        delete_key: ''
      },
      visibleHistory: false,
      data: {
        header: [],
        detil: []
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  beforeCreate() {
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeFormat",
      "getIsSpecialMenu",
      "getStandartFormatDate",
    ]),
    columns() {
      const kolom = [
        {
            title: "#",
            width: '50px',
            scopedSlots: { customRender: "no" },
          },
          {
            title: "Cost Center",
            width: '150px',
            scopedSlots: { customRender: "cost_center" },
          },
          {
            title: "Code | Item Budget",
            width: '350px',
            scopedSlots: { customRender: "code_budget" },
          },
          {
            title: "Description",
            scopedSlots: { customRender: "description" },
          },
          {
            title: "Value",
            width: '150px',
            scopedSlots: { customRender: "nilai" },
          },
          //{
          //  title: "#",
          //  width: '50px',
          //  fixed: "right",
          //  scopedSlots: { customRender: "aksi" },
          //},
      ];
      return kolom;
    },
    totalValue(){
      return _.sumBy(this.data.detil, function (val) {
        return Number(val.nilai_rencana)
      });
    }
  },
  methods: {
    moment,
    fetchManifest() {
      this.loading.page = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "rencana_belanja",
        params: {
          rencana_belanja_id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          console.log(response)
          this.data = {
            header: response.data.hdr[0],
            detil: response.data.dtl
          }
          this.loading.page = false;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    handleDelete(item){
      const that = this

      this.$confirm({
        title: "Are you sure to delete?",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.delete_key = item.rencana_belanja_dtl_id

          that.asyncAxiosDelete(
            "Rencana_belanja/hapus",
            "application/json",
            that.getAuth,
            { rencana_belanja_dtl_id: item.rencana_belanja_dtl_id }
          )
          .then((response) => {
            that.loading.delete_key = ''

            that.data.dtl = response.dtl

            if (response.status && response.status == true) {
              that.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              that.displayMessageValue("error-other", responses);
            }
          })
          .catch(() => {
            that.loading.delete_key = ''
          });
        },
        onCancel() {
        }
      });
    },
    handleEdit(){
      this.$router.push({
        name: (this.$route.name=='expenditurePlanManifestAL' ? "expenditurePlanReviseAL" : "expenditurePlanRevisePimpro"),
        params: { id: this.id}
      });
    }
  },
  mounted() {
    this.fetchManifest();
  },
  beforeDestroy() {
  },
};
</script>

<style></style>
